import { useMemo } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { SearchSuggestionsInput } from "types/generated";

import { makeStackTasksPredicates } from "../useSearchTasks/predicates";
import { SEARCH_STACK_TASKS_SUGGESTIONS } from "./gql";

const useSearchStackTasksSuggestions = (
  stackId: string,
  input: Omit<SearchSuggestionsInput, "predicates">
) => {
  const predicates = useMemo(() => makeStackTasksPredicates(stackId), [stackId]);

  const { data, previousData, error, loading } = usePolledQuery(SEARCH_STACK_TASKS_SUGGESTIONS, {
    variables: { input: { ...input, predicates } },
    pollingGroup: PollingIntervalGroups.Lists,
    nextFetchPolicy: "cache-first",
  });

  const totalCount = (data ?? previousData)?.searchRunsSuggestions.filteredCount ?? 0;

  return { totalCount, error, loading };
};

export default useSearchStackTasksSuggestions;
